import * as React from "react";

function SvgRockerbox(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 55 64.643"
      {...{ ...props, ref }}
    >
      <path fill="#C6E4F0" d="M14.282 21.795h15.061v15.151H14.282z" />
      <path fill="#AED6E4" d="M0 36.078V64.643h14.843V36.078z" />
      <path fill="#C6E4F0" d="M42.847 7.513H57.13v14.809H42.847z" />
      <path fill="#51A2CB" d="M14.283 36.078V64.643h14.81V36.078z" />
      <path fill="#51A2CB" d="M42.848 21.796H28.565v14.901H57.13V21.796z" />
      <path
        fill="#2573B9"
        d="M42.848 36.078H28.565V64.643h14.283V50.36H57.13V36.078z"
      />
      <path fill="#034566" d="M42.434 49.948H57.13v14.694H42.434z" />
    </svg>
  );
}

export default React.forwardRef(SvgRockerbox);
